module.exports = __webpack_public_path__ + "img/logo.cea23d08.png";